// outpost-crm-ui/src/googleMapsLoader.js
// Shared Google Maps JS loader. Singleton — loads exactly once per page.
// Loads the Places library so Autocomplete is available across the app.
//
// Reads the API key from REACT_APP_GOOGLE_MAPS_API_KEY (Vercel env var).
// That key needs the following APIs enabled in Google Cloud:
//   - Maps JavaScript API
//   - Places API   (for the Autocomplete widget)
//   - Geocoding API (optional — backend already uses backend key for that)

let _promise = null;

export function loadGoogleMaps() {
  if (_promise) return _promise;
  if (typeof window !== "undefined" &&
      window.google && window.google.maps && window.google.maps.places) {
    _promise = Promise.resolve(window.google.maps);
    return _promise;
  }
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) {
    return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY not set"));
  }
  _promise = new Promise((resolve, reject) => {
    const existing = document.querySelector("script[data-outpost-gmaps]");
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google.maps));
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&v=weekly`;
    s.async = true;
    s.defer = true;
    s.dataset.outpostGmaps = "1";
    s.onload = () => resolve(window.google.maps);
    s.onerror = (e) => reject(e);
    document.head.appendChild(s);
  });
  return _promise;
}
